export default "__VITE_ASSET__BZ$H7DT3__"